<template>
    <div class="h-full p-2">
        <hts-form :rules="rules">
            <hts-form-button loading>
                ASD
            </hts-form-button>
            <hts-form-button
                color="primary"
                class="w-full"
                size="mini">
                Open Modal2
            </hts-form-button>
            <hts-form-button
                color="primary"
                class="w-full">
                Open Modal2
            </hts-form-button>
            <hts-form-button color="primary">
                Open Modal2
            </hts-form-button>
            <hts-form-button
                color="primary"
                :outline="false">
                Open Modal2
            </hts-form-button>
            <hts-form-button
                color="info"
                :outline="false"
                size="mini">
                Open Modal2
            </hts-form-button>
            <hts-form-button
                color="primary"
                size="mini">
                Open Modal2
            </hts-form-button>
            <hts-form-button
                color="primary"
                type="icon"
                icon-name="hi-x-mark-icon"
                size="v-mini">
                Open Modal2
            </hts-form-button>
            <hts-form-button
                color="primary"
                type="icon"
                icon-name="hi-x-mark-icon"
                size="mini">
                Open Modal2
            </hts-form-button>
            <hts-form-button
                color="primary"
                type="icon"
                icon-name="hi-x-mark-icon"
                size="small">
                Open Modal2
            </hts-form-button>
            <hts-form-button
                color="primary"
                type="icon"
                icon-name="hi-x-mark-icon">
                Open Modal2
            </hts-form-button>
            <hts-form-button
                color="primary"
                type="icon"
                icon-name="hi-x-mark-icon"
                size="large">
                Open Modal2
            </hts-form-button>
            <hts-form-button
                color="primary"
                type="icon"
                icon-name="hi-x-mark-icon"
                size="xl">
                Open Modal2
            </hts-form-button>
            <hts-form-button
                color="primary"
                type="icon"
                icon-name="hi-x-mark-icon"
                size="2xl">
                Open Modal2
            </hts-form-button>
            <hts-form-button
                color="primary"
                type="icon"
                icon-name="hi-x-mark-icon"
                size="3xl">
                Open Modal2
            </hts-form-button>
            <hts-select-vehicle
                v-model="vehicle"
                v-model:name="vehicleText"
                label="Vehicle" />
            <hts-form-select
                v-model="select"
                label="Select"
                color="primary"
                required
                :items="items"
                creatable
                @create-new="createNew" />
            select value: {{ select }}
            <hts-form-checkbox
                v-model="checkbox"
                label="Checkbox"
                color="secondary"
                required
                :items="items" />
            check value: {{ checkbox }}
            <hts-form-checkbox
                v-model="checkbox"
                check-all
                label="Checkbox"
                color="info"
                :items="items" />
            check value: {{ checkbox }}
            <hts-form-checkbox
                v-model="toggle"
                label="Checkbox"
                color="warning"
                required
                :items="items" />
            check value: {{ toggle }}
            <hts-form-toggle
                v-model="toggle"
                label="Toggle"
                color="warning"
                required />
            toggle value: {{ toggle }}
            <hts-form-radio
                v-model="selectRadio"
                label="Radio"
                color="error"
                required
                :items="[
                    { id: 123, label: 'a' },
                    { id: 1234, label: 'b' }
                ]" />
            radio value: {{ selectRadio }}
            <hts-divider />
            <hts-form-button-group
                v-model="selectButton"
                :items="[
                    { id: 123, label: 'asfasd' },
                    { id: 123, label: 'asfasd' },
                    { id: 1234, label: 'asfasd' }
                ]" />
            button value: {{ selectButton }}
            <hts-divider />
            <hts-dropdown
                :options="[
                    { label: 'asdasd', value: 1 },
                    { label: 'a3', value: 2 },
                    { label: 'at5', value: 3 }
                ]">
                <template #reference>
                    <hts-form-button
                        color="error"
                        size="large">
                        Select
                    </hts-form-button>
                </template>
            </hts-dropdown>
            <hts-divider />
            <hts-dropdown
                :options="[
                    { label: 'sweee', value: 222 },
                    { label: '888', value: 777 }
                ]">
                <template #reference>
                    <hts-form-button
                        color="error"
                        size="mini">
                        Select 2
                    </hts-form-button>
                </template>
            </hts-dropdown>
            <hts-divider />
            year value: {{ year }}
            <hts-form-date
                v-if="false"
                v-model="year"
                type="year"
                prop="year"
                required
                label="Year" />
            month value: {{ month }}
            <hts-form-date
                v-if="false"
                v-model="month"
                type="month"
                prop="month"
                required
                label="Month"
                color="success"
                size="small" />
            date value: {{ date }}
            <hts-form-date
                v-if="false"
                v-model="date"
                type="date"
                prop="date"
                required
                label="Date"
                size="large" />
            datetime value: {{ datetime }}
            <hts-form-date
                v-if="false"
                v-model="datetime"
                type="datetime"
                prop="datetime"
                required
                label="Datetime"
                color="success" />
            daterange value: {{ daterange }}
            <hts-form-date
                v-if="false"
                v-model="daterange"
                type="date"
                range
                prop="daterange"
                required
                label="Daterange"
                color="error"
                size="mini" />
            <hts-divider />
            input value: {{ input }}
            <hts-form-input
                v-model="input"
                size="large"
                prop="input"
                required
                label="Input"
                color="success">
                <template #prefix>
                    prefix
                </template>
                <template #suffix>
                    suffix
                </template>
            </hts-form-input>
            <hts-form-input
                v-model="input"
                type="password"
                prop="input"
                required
                label="Input password"
                color="success" />
            <hts-form-input
                v-model="inputNumber"
                type="number"
                prop="inputNumber"
                required
                label="Input number"
                color="success" />
            <hts-form-input
                v-model="inputNumber"
                type="number"
                prop="inputNumber"
                required
                label="Input number"
                color="success" />
            <hts-form-input
                v-model="input"
                size="mini"
                prop="input"
                required
                label="Input"
                color="error">
                <template #prefix>
                    prefix
                </template>
                <template #suffix>
                    suffix
                </template>
            </hts-form-input>
            <hts-form-input
                v-model="input"
                size="small"
                prop="input"
                disabled
                label="Input disabled"
                color="error">
                <template #suffix>
                    suffix
                </template>
            </hts-form-input>
            <hts-form-input
                v-model="input"
                prop="input"
                readonly
                label="Input readonly"
                color="warning" />
            <hts-divider />
            input value: {{ input }}
            <hts-form-textarea
                v-model="input"
                prop="textarea"
                required
                label="Textarea"
                color="warning" />
            <hts-form-textarea
                v-model="input"
                size="large"
                prop="textarea"
                required
                label="Textarea"
                color="warning" />
            <hts-divider />
            <hts-form-file
                v-model="file"
                required
                label="Input file"
                color="secondary" />
            {{ file }}
            {{ typeof file }}
            <hts-form-file
                v-model="files"
                multiple
                required
                label="Input file"
                color="secondary" />
            {{ files }}
            {{ typeof files }}
            <hts-form-select
                v-model="select"
                :items="[{ label: 'A', value: 'A' }]"
                size="large"
                multiple
                required
                label="Input select"
                color="secondary" />
            {{ select }}
        </hts-form>
        <hts-divider />
        <hts-form-button
            color="success"
            size="mini"
            @click="visible = true">
            Open Drawer
        </hts-form-button>
        <hts-divider />
        <hts-form-button
            color="primary"
            size="mini"
            @click="visible2 = true">
            Open Modal
        </hts-form-button>
        <hts-divider />
        <hts-modal v-model="visible2">
            <hts-form-checkbox
                v-model="checkbox"
                type="list"
                label="Checkbox"
                color="secondary"
                required
                :items="items" />
            <hts-form-radio
                v-model="selectRadio"
                label="Radio"
                color="error"
                required
                :items="[
                    { id: 0, label: 'a a a a a a a a a a a a a a a a a a a a a a' },
                    { id: 2, label: 'b a a a a a a a a a a a a a a a a a a a a a' },
                    { id: 3, label: 'b a a a a a a a a a a a a a a a' },
                    { id: 5, label: 'b a a a a a a a a a a a a a a a' },
                    { id: 7, label: 'b a a a a a a a a a a a a a a a a a a' },
                    { id: 8, label: 'b a a a a a a a a a a a a a a a a a a' }
                ]" />
            <hts-form-button
                color="primary"
                class="w-full"
                size="mini"
                @confirm="visible3 = true">
                Open Modal2
            </hts-form-button>
        </hts-modal>
        <hts-modal v-model="visible3">
            ASDASD asdasd asd asd asd
        </hts-modal>
        <hts-drawer
            v-model="visible"
            title="Drawer">
            ASDASD asdasd asd asd asd
        </hts-drawer>
        <div class="flex justify-between">
            <div class="flex flex-col">
                <span class="text-2xl font-bold">
                    {{ $t('labels.hello') }}, {{ userName }}
                </span>
                <span class="text-xl">
                    {{ $t('labels.introduction') }}
                </span>
            </div>
            <div class="flex">
                <hts-form-button
                    color="transparent"
                    icon-name="hi-cloud-arrow-down-icon"
                    icon-position="right"
                    type="submit">
                    {{ $t('labels.downloadReport') }}
                </hts-form-button>
                <hts-form-button
                    color="main"
                    icon-name="hi-chart-pie-icon"
                    icon-position="right"
                    type="submit">
                    {{ $t('labels.viewStatic') }}
                </hts-form-button>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
const store = $store()
const items = ref([
  {
    label: 'label',
    value: 'value'
  },
  {
    label: 'labe2l',
    value: 'value2'
  },
  {
    label: 'label3',
    value: 'value3'
  }
])
const selectItems = ref([])
const checkbox = ref(['value'])
const toggle = ref(true)
const selectRadio = ref(123)
const selectButton = ref(123)
const visible = ref(false)
const visible2 = ref(false)
const visible3 = ref(false)
const userName = ref('')
const input = ref('test input')
const inputNumber = ref(1234556)
const date = ref('')
const year = ref('')
const month = ref('')
const vehicle = ref('63ff1e19b9e46968a6f826ba')
const vehicleText = ref('Vehicle Text')
const datetime = ref('2023-01-30T07:54:12.699Z')

const daterange = ref(['2023-01-30T07:54:12.699Z', '2023-01-30T07:54:12.699Z'])
const file = ref<File | undefined>(undefined)
const files = ref<File[] | undefined>(undefined)
const select = ref('')

const rules = ref({
  date: 'required',
  input: 'required',
  file: 'required'
})
const createNew = () => {
  alert('create')
}
onMounted(() => {
  checkUserName()
})
const checkUserName = () => {
  const user: { [key: string]: any } = store.userConfig.getUser
  userName.value = user.fullName
}
</script>
